export const SKELETON_COUNT = 8;
